"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('underscore'),
  uniq = _require.uniq,
  without = _require.without;
var LegalDocsPicker = /*#__PURE__*/function () {
  LegalDocsPicker.$inject = ["EventEmitter", "orgService", "modalService", "legalDocumentsService", "userService"];
  /* @ngInject */
  function LegalDocsPicker(EventEmitter, orgService, modalService, legalDocumentsService, userService) {
    _classCallCheck(this, LegalDocsPicker);
    this.EventEmitter = EventEmitter;
    this.orgService = orgService;
    this.modalService = modalService;
    this.legalDocsService = legalDocumentsService;
    this.userService = userService;
  }
  _createClass(LegalDocsPicker, [{
    key: "$onInit",
    value: function $onInit() {
      if (!this.model) {
        this.model = [];
        this.startAddingNewItem();
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this = this;
      if (changes.orgId && this.orgId) {
        this.orgName = this.orgService.getNameFromId(this.orgId);
        this.canCreateNewDoc = this.userService.matchesRoles({
          globalRole: 'superadmin'
        }, {
          orgRole: 'admin',
          orgId: this.orgId
        });
        this.isOrgVisible().then(function (isVisible) {
          return isVisible ? _this.loadLegalDocs() : undefined;
        });
      }
      if (changes.model && this.model) {
        this.model = angular.copy(this.model);
      }
    }

    // check it the user can view this org
  }, {
    key: "isOrgVisible",
    value: function isOrgVisible() {
      var _this2 = this;
      this._orgIsVisible = this._orgIsVisible || this.userService.getCurrentUserOrgs().then(function (orgs) {
        _this2.orgIsVisible = _.some(orgs, function (org) {
          return org.id === _this2.orgId;
        });
        return _this2.orgIsVisible;
      });
      return this._orgIsVisible;
    }
  }, {
    key: "loadLegalDocs",
    value: function loadLegalDocs() {
      var _this3 = this;
      if (this.loading) return;
      this.loading = true;
      return this.legalDocsService.getLegalDocumentsForOrg(this.orgName).then(function (docs) {
        return _this3.allLegalDocs = docs;
      }).catch(function () {
        return _this3.error = true;
      }).finally(function () {
        return _this3.loading = false;
      });
    }
  }, {
    key: "startAddingNewItem",
    value: function startAddingNewItem() {
      this.addingNewItem = true;
    }
  }, {
    key: "finishAddingNewItem",
    value: function finishAddingNewItem() {
      if (this.newItem && this.model.indexOf(this.newItem) === -1) {
        this.model.push(this.newItem);
        this.sendChange();
      }
      this.newItem = null;
      this.addingNewItem = false;
    }
  }, {
    key: "onItemChange",
    value: function onItemChange() {
      this.model = uniq(this.model);
      this.sendChange();
    }
  }, {
    key: "removeItem",
    value: function removeItem(index) {
      this.model = without(this.model, this.model[index]);
      if (this.model.length === 0) {
        this.startAddingNewItem();
      }
      this.sendChange();
    }
  }, {
    key: "createNewDoc",
    value: function createNewDoc() {
      var _this4 = this;
      if (!this.canCreateNewDoc) return;
      this.modalService.openModalWithComponent({
        title: 'Create a new document',
        saveLabel: 'Create',
        component: 'bs-legal-doc-editor',
        args: {
          model: {}
        }
      }).then(function (model) {
        return _this4.legalDocsService.createLegalDocumentForOrg(_this4.orgName, model).then(function (_ref) {
          var id = _ref.id;
          return _this4.loadLegalDocs().then(function () {
            _this4.model.push(id);
            _this4.onItemChange();
          });
        });
      });
    }
  }, {
    key: "sendChange",
    value: function sendChange() {
      this.onChange(this.EventEmitter({
        legalDocuments: this.model
      }));
    }
  }]);
  return LegalDocsPicker;
}();
module.exports = angular.module('backstage.components.common.legal-docs-picker', ['backstage.services']).component('bsLegalDocsPicker', {
  templateUrl: '/src/angular/components/common/legal-docs-picker/legal-docs-picker.html',
  bindings: {
    model: '<',
    orgId: '<',
    onChange: '&'
  },
  controller: LegalDocsPicker
}).name;